<template>
  <div class="text-grey-300 text-15">
    <div class="font-semibold text-app-color flex items-center">
      <div class="w-3 rounded-2 h-21 mr-10" :style="userColor" />
      {{ user.firstName }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import userColorMixin from '@/mixins/userColorMixin'

export default defineComponent({
  props: {
    user: Object
  },

  setup (props) {
    const { userColor } = userColorMixin(props.user.color)
    return {
      // ref
      // data
      userColor
      // computed
      // function
    }
  }
})
</script>
